'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.5 0c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16 7.163-16 16-16Zm0 2.667C9.136 2.667 3.167 8.637 3.167 16c0 7.364 5.97 13.333 13.333 13.333 7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333Zm.026 18.191c.917 0 1.68.707 1.718 1.628v.147c.043.902-.796 1.692-1.718 1.692-.958 0-1.76-.79-1.76-1.733 0-.943.802-1.734 1.76-1.734ZM18.16 8.181c.12.278.162.555.162.867-.028.578-.072 1.156-.11 1.733l-.052.867-.24 4.015c-.042.436-.042.832-.042 1.261a1.307 1.307 0 0 1-1.317 1.262c-.718 0-1.275-.513-1.317-1.22-.12-2.087-.24-4.132-.359-6.22l-.12-1.65c0-.908.521-1.656 1.36-1.892.838-.194 1.676.2 2.035.977Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var CautionOutline = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.CautionOutline = CautionOutline;